export const PROJECT_MANAGEMENT = 'project-management'
export const MAP_VIEW = 'map-view'
export const DEM_EXTRACTION = 'dem-extraction'
export const TASKS = 'tasks'
export const DATA = 'data'
export const DEMO_TASKS = 'demo-tasks'
export const CITY_GENERATION = 'city-generation'
export const CHAT_ORCHESTRATION = 'chat-orchestration'
export const UPLOAD_DATA = 'upload-data'
export const DATA_EXPLORATION = 'data-exploration'
export const CHANGE_DETECTION = 'change-detection'

export type MenuIconKey =
  'terrain-analysis' | 'city' | 'dem' | 'data' | 'tasks' | 'exploration' | 'change-detection'
